module.exports = __webpack_public_path__ + "assets/images/figurine_karla.45f0908.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/figurines/figurine_karla.png
// module id = 354
// module chunks = 1